// extracted by mini-css-extract-plugin
export default {"cls1":"OverlappingAvatars-cls1_jKX","cls2":"OverlappingAvatars-cls2_rWt OverlappingAvatars-cls1_jKX"};